<template>
  <!-- 民办非业务活动表-->
  <div class="big_box4">
    <div class="top_title3">
      <h5>业务活动表（月报）</h5>
      <div class="bottom_font clearfix">
        <h6 class="left">纳税人名称：<span>{{comName}}</span></h6>
        <h6 class="center"><span>{{durationOfTaxTime}}</span></h6>
        <h6 class="right">
          <p>单位：元</p>
          <p>纳税人识别号：<span>{{taxNo}}</span></p>
        </h6>
      </div>
    </div>
    <table class="content" cellspacing="0">
      <tr class="top_bg">
        <td class="center" style="width:18%;" rowspan="2">项目</td>
        <td class="center" style="width:4%;" rowspan="2">行次</td>
        <td class="center" style="width:39%;" colspan="3">本月数</td>
        <td class="center" style="width:39%;" colspan="3">本年累计数</td>
      </tr>
      <tr class="top_bg">
        <td class="center" style="width:13%;">非限定性</td>
        <td class="center" style="width:13%;">限定性</td>
        <td class="center" style="width:13%;">合计</td>
        <td class="center" style="width:13%;">非限定性</td>
        <td class="center" style="width:13%;">限定性</td>
        <td class="center" style="width:13%;">合计</td>
      </tr>
    </table>
    <div class="fixed_box_table" :style="{height:contentStyleObj}">
      <table class="content" cellspacing="0">
        <tr>
          <td class="weight" style="width:18%;">一、收入</td>
          <td style="width:4%;" class="center">1</td>
          <td style="width:13%;"></td>
          <td style="width:13%;"></td>
          <td style="width:13%;"></td>
          <td style="width:13%;"></td>
          <td style="width:13%;"></td>
          <td style="width:13%;"></td>
        </tr>

        <tr>
          <td class="left_k">其中：捐赠收入</td>
          <td class="center">2</td>
          <qzf-td @change="changeList()" v-model:amount="list[1].periodFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[1].periodXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[1].qmyeZc"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[1].yearFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[1].yearXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[1].ncyeQy"></qzf-td>
        </tr>
        <tr>
          <td class="left_k">会费收入</td>
          <td class="center">3</td>
          <qzf-td @change="changeList()" v-model:amount="list[2].periodFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[2].periodXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[2].qmyeZc"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[2].yearFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[2].yearXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[2].ncyeQy"></qzf-td>
        </tr>

        <tr>
          <td class="left_k">提供服务收入</td>
          <td class="center">4</td>
          <qzf-td @change="changeList()" v-model:amount="list[3].periodFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[3].periodXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[3].qmyeZc"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[3].yearFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[3].yearXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[3].ncyeQy"></qzf-td>
        </tr>

        <tr>
          <td class="left_k">商品销售收入</td>
          <td class="center">5</td>
          <qzf-td @change="changeList()" v-model:amount="list[4].periodFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[4].periodXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[4].qmyeZc"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[4].yearFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[4].yearXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[4].ncyeQy"></qzf-td>
        </tr>

        <tr>
          <td class="left_k">政府补助收入</td>
          <td class="center">6</td>
          <qzf-td @change="changeList()" v-model:amount="list[5].periodFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[5].periodXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[5].qmyeZc"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[5].yearFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[5].yearXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[5].ncyeQy"></qzf-td>
        </tr>
        <tr>
          <td class="left_k">投资收益</td>
          <td class="center">7</td>
          <qzf-td @change="changeList()" v-model:amount="list[6].periodFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[6].periodXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[6].qmyeZc"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[6].yearFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[6].yearXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[6].ncyeQy"></qzf-td>
        </tr>
        <tr>
          <td class="left_k">其他收入</td>
          <td class="center">8</td>
          <qzf-td @change="changeList()" v-model:amount="list[7].periodFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[7].periodXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[7].qmyeZc"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[7].yearFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[7].yearXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[7].ncyeQy"></qzf-td>
        </tr>
        <tr>
          <td class="weight">收入合计</td>
          <td class="center">9</td>
          <qzf-td @change="changeList()" v-model:amount="list[8].periodFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[8].periodXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[8].qmyeZc"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[8].yearFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[8].yearXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[8].ncyeQy"></qzf-td>
        </tr>
        
        <tr>
          <td class="weight">二、费用</td>
          <td class="center">10</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td class="weight">（一）业务活动成本</td>
          <td class="center">11</td>
          <qzf-td @change="changeList()" v-model:amount="list[10].periodFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[10].periodXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[10].qmyeZc"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[10].yearFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[10].yearXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[10].ncyeQy"></qzf-td>
        </tr>
        <tr>
          <td class="left_k">其中：</td>
          <td class="center">12</td>
          <qzf-td @change="changeList()" v-model:amount="list[11].periodFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[11].periodXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[11].qmyeZc"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[11].yearFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[11].yearXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[11].ncyeQy"></qzf-td>
        </tr>
        <tr>
          <td class="left_k"></td>
          <td class="center">13</td>
          <qzf-td @change="changeList()" v-model:amount="list[12].periodFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[12].periodXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[12].qmyeZc"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[12].yearFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[12].yearXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[12].ncyeQy"></qzf-td>
        </tr>
        <tr>
          <td class="left_k"></td>
          <td class="center">14</td>
          <qzf-td @change="changeList()" v-model:amount="list[13].periodFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[13].periodXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[13].qmyeZc"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[13].yearFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[13].yearXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[13].ncyeQy"></qzf-td>
        </tr>
        <tr>
          <td class="left_k"></td>
          <td class="center">15</td>
          <qzf-td @change="changeList()" v-model:amount="list[14].periodFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[14].periodXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[14].qmyeZc"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[14].yearFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[14].yearXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[14].ncyeQy"></qzf-td>
        </tr>
        <tr>
          <td class="left_k">（二）管理费用</td>
          <td class="center">16</td>
          <qzf-td @change="changeList()" v-model:amount="list[15].periodFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[15].periodXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[15].qmyeZc"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[15].yearFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[15].yearXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[15].ncyeQy"></qzf-td>
        </tr>
        <tr>
          <td class="left_k">（三）筹资费用</td>
          <td class="center">17</td>
          <qzf-td @change="changeList()" v-model:amount="list[16].periodFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[16].periodXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[16].qmyeZc"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[16].yearFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[16].yearXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[16].ncyeQy"></qzf-td>
        </tr>
        <tr>
          <td class="weight">（四）其他费用</td>
          <td class="center">18</td>
          <qzf-td @change="changeList()" v-model:amount="list[17].periodFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[17].periodXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[17].qmyeZc"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[17].yearFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[17].yearXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[17].ncyeQy"></qzf-td>
        </tr>
        <tr>
          <td class="weight">费用合计</td>
          <td class="center">19</td>
          <qzf-td @change="changeList()" v-model:amount="list[18].periodFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[18].periodXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[18].qmyeZc"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[18].yearFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[18].yearXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[18].ncyeQy"></qzf-td>
        </tr>
        <tr>
          <td>三、限定性净资产转为非限定性净资产</td>
          <td class="center">20</td>
          <qzf-td @change="changeList()" v-model:amount="list[19].periodFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[19].periodXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[19].qmyeZc"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[19].yearFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[19].yearXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[19].ncyeQy"></qzf-td>
        </tr>
        <tr>
          <td>四、净资产变动额（若为净资产减少额，以“-”号填列）</td>
          <td class="center">21</td>
          <qzf-td @change="changeList()" v-model:amount="list[20].periodFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[20].periodXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[20].qmyeZc"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[20].yearFxdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[20].yearXdxTotal"></qzf-td>
          <qzf-td @change="changeList()" v-model:amount="list[20].ncyeQy"></qzf-td>
        </tr>

      </table>
    </div>
    <div class="save_box">
      <el-button type="primary" size="small" plain @click="saveLrb">保存</el-button>
    </div>
  </div>
</template>

<script>
import { gsInfo , gsEdit} from '@/api/taxCalculation.js'

export default {
  name: 'finance',
  components: { },
  data() {
    return {
      fullscreenLoading: false,
      durationOfTaxTime: '',
      list:[{"id":156,"kjMainId":14,"type":1,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":157,"kjMainId":14,"type":2,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":158,"kjMainId":14,"type":3,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":159,"kjMainId":14,"type":4,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":160,"kjMainId":14,"type":5,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":161,"kjMainId":14,"type":6,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":162,"kjMainId":14,"type":7,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":163,"kjMainId":14,"type":8,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":164,"kjMainId":14,"type":9,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":165,"kjMainId":14,"type":10,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":166,"kjMainId":14,"type":11,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":167,"kjMainId":14,"type":12,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":168,"kjMainId":14,"type":13,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":169,"kjMainId":14,"type":14,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":170,"kjMainId":14,"type":15,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":171,"kjMainId":14,"type":16,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":172,"kjMainId":14,"type":17,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":173,"kjMainId":14,"type":18,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":174,"kjMainId":14,"type":19,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":175,"kjMainId":14,"type":20,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":176,"kjMainId":14,"type":21,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":177,"kjMainId":14,"type":22,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":178,"kjMainId":14,"type":23,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":179,"kjMainId":14,"type":24,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":180,"kjMainId":14,"type":25,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":181,"kjMainId":14,"type":26,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":182,"kjMainId":14,"type":27,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":183,"kjMainId":14,"type":28,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":184,"kjMainId":14,"type":29,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":185,"kjMainId":14,"type":30,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0},{"id":186,"kjMainId":14,"type":31,"zcxmmc":"","qmyeZc":0,"yearFxdxTotal":0,"qyxmmc":"","yearXdxTotal":0,"ncyeQy":0}],
      comName:this.$store.getters['user/comInfo'].comName,
      taxNo:this.$store.getters['user/comInfo'].taxNo,
      contentStyleObj:{}, //高度变化
    }
  },
  created() {
    // 获取窗口高度
    this.contentStyleObj=this.$getHeight(386)
  },
  methods: {
    changeList(){
      //合计
      this.list[1].qmyeZc = (this.list[1].periodFxdxTotal  + this.list[1].periodXdxTotal ).toFixed(2)*1
      this.list[2].qmyeZc = (this.list[2].periodFxdxTotal  + this.list[2].periodXdxTotal ).toFixed(2)*1
      this.list[3].qmyeZc = (this.list[3].periodFxdxTotal  + this.list[3].periodXdxTotal ).toFixed(2)*1
      this.list[4].qmyeZc = (this.list[4].periodFxdxTotal  + this.list[4].periodXdxTotal ).toFixed(2)*1
      this.list[5].qmyeZc = (this.list[5].periodFxdxTotal  + this.list[5].periodXdxTotal ).toFixed(2)*1
      this.list[6].qmyeZc = (this.list[6].periodFxdxTotal  + this.list[6].periodXdxTotal ).toFixed(2)*1
      this.list[7].qmyeZc = (this.list[7].periodFxdxTotal  + this.list[7].periodXdxTotal ).toFixed(2)*1
      this.list[8].qmyeZc = (this.list[8].periodFxdxTotal  + this.list[8].periodXdxTotal ).toFixed(2)*1
      this.list[9].qmyeZc = (this.list[9].periodFxdxTotal  + this.list[9].periodXdxTotal ).toFixed(2)*1
      this.list[10].qmyeZc = (this.list[10].periodFxdxTotal  + this.list[10].periodXdxTotal ).toFixed(2)*1
      this.list[11].qmyeZc = (this.list[11].periodFxdxTotal  + this.list[11].periodXdxTotal ).toFixed(2)*1
      this.list[12].qmyeZc = (this.list[12].periodFxdxTotal  + this.list[12].periodXdxTotal ).toFixed(2)*1
      this.list[13].qmyeZc = (this.list[13].periodFxdxTotal  + this.list[13].periodXdxTotal ).toFixed(2)*1
      this.list[14].qmyeZc = (this.list[14].periodFxdxTotal  + this.list[14].periodXdxTotal ).toFixed(2)*1
      this.list[15].qmyeZc = (this.list[15].periodFxdxTotal  + this.list[15].periodXdxTotal ).toFixed(2)*1
      this.list[16].qmyeZc = (this.list[16].periodFxdxTotal  + this.list[16].periodXdxTotal ).toFixed(2)*1
      this.list[17].qmyeZc = (this.list[17].periodFxdxTotal  + this.list[17].periodXdxTotal ).toFixed(2)*1
      this.list[18].qmyeZc = (this.list[18].periodFxdxTotal  + this.list[18].periodXdxTotal ).toFixed(2)*1
      this.list[19].qmyeZc = (this.list[19].periodFxdxTotal  + this.list[19].periodXdxTotal ).toFixed(2)*1
      this.list[20].qmyeZc = (this.list[20].periodFxdxTotal  + this.list[20].periodXdxTotal ).toFixed(2)*1

      this.list[1].ncyeQy = (this.list[1].yearFxdxTotal  + this.list[1].yearXdxTotal ).toFixed(2)*1
      this.list[2].ncyeQy = (this.list[2].yearFxdxTotal  + this.list[2].yearXdxTotal ).toFixed(2)*1
      this.list[3].ncyeQy = (this.list[3].yearFxdxTotal  + this.list[3].yearXdxTotal ).toFixed(2)*1
      this.list[4].ncyeQy = (this.list[4].yearFxdxTotal  + this.list[4].yearXdxTotal ).toFixed(2)*1
      this.list[5].ncyeQy = (this.list[5].yearFxdxTotal  + this.list[5].yearXdxTotal ).toFixed(2)*1
      this.list[6].ncyeQy = (this.list[6].yearFxdxTotal  + this.list[6].yearXdxTotal ).toFixed(2)*1
      this.list[7].ncyeQy = (this.list[7].yearFxdxTotal  + this.list[7].yearXdxTotal ).toFixed(2)*1
      this.list[8].ncyeQy = (this.list[8].yearFxdxTotal  + this.list[8].yearXdxTotal ).toFixed(2)*1
      this.list[9].ncyeQy = (this.list[9].yearFxdxTotal  + this.list[9].yearXdxTotal ).toFixed(2)*1
      this.list[10].ncyeQy = (this.list[10].yearFxdxTotal  + this.list[10].yearXdxTotal ).toFixed(2)*1
      this.list[11].ncyeQy = (this.list[11].yearFxdxTotal  + this.list[11].yearXdxTotal ).toFixed(2)*1
      this.list[12].ncyeQy = (this.list[12].yearFxdxTotal  + this.list[12].yearXdxTotal ).toFixed(2)*1
      this.list[13].ncyeQy = (this.list[13].yearFxdxTotal  + this.list[13].yearXdxTotal ).toFixed(2)*1
      this.list[14].ncyeQy = (this.list[14].yearFxdxTotal  + this.list[14].yearXdxTotal ).toFixed(2)*1
      this.list[15].ncyeQy = (this.list[15].yearFxdxTotal  + this.list[15].yearXdxTotal ).toFixed(2)*1
      this.list[16].ncyeQy = (this.list[16].yearFxdxTotal  + this.list[16].yearXdxTotal ).toFixed(2)*1
      this.list[17].ncyeQy = (this.list[17].yearFxdxTotal  + this.list[17].yearXdxTotal ).toFixed(2)*1
      this.list[18].ncyeQy = (this.list[18].yearFxdxTotal  + this.list[18].yearXdxTotal ).toFixed(2)*1
      this.list[19].ncyeQy = (this.list[19].yearFxdxTotal  + this.list[19].yearXdxTotal ).toFixed(2)*1
      this.list[20].ncyeQy = (this.list[20].yearFxdxTotal  + this.list[20].yearXdxTotal ).toFixed(2)*1
      
    },
    getList(){
      let param = {
        tableName:'kj_lrb',
        itemName:'month',
        
      }
      gsInfo(param).then(res=>{
        if(res.data.data.info){
          this.list = res.data.data.info
          this.durationOfTaxTime = res.data.data.time
          this.comName = res.data.data.name
          this.taxNo = res.data.data.taxNo
          this.changeList()
        }
      })
    },
    saveLrb(){
      let param = {
        tableName:'kj_lrb',
        items:this.list,
        itemName:'month',

      }
      gsEdit(param).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("保存成功")
          this.getList()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.save_box{
  margin: 0 auto;
  margin-top: 20px;
  text-align: center;
}
.content{
  // width: 2000px;
  width: 100%;
  margin: 0 auto;
  border:1px solid #c2c2c2;
  border-bottom: none;
  border-right: none;
  margin-top: 10px;
 
  span{
    line-height: 28px;
    font-size: 14px;
  }
  tr{
    padding: 0;
    margin: 0;
  }
  td{
    border-right:1px solid #c2c2c2;
    border-bottom:1px solid #c2c2c2;
    line-height: 28px;
    padding:0 6px;
    color: #333;
    font-size: 14px;
  }
  input{
    width: 100%;
    line-height: 28px;
    padding: 0 6px;
    font-size: 14px;
    padding-right:20px;
  }
}
.left_k{
  text-indent: 2em;
}
.left_b{
  text-indent: 4em;
}
.left_x{
  text-indent:5em;
}
.left_d{
  text-indent:8em;
}
.top_title3{
  width: 100%;
  margin: 0 auto;
  h5{
    font-size: 20px;
    color: #333;
    font-weight: 700;
    text-align: center;
  }
  .bottom_font{
    width: 100%;
    margin: 0 auto;
    margin-top: 10px;
    // position: relative;
    h6{
      float: left;
      width: 33.33%;
      font-size: 14px;
      color: #333;
      font-weight: normal;
      // position: absolute;
      // bottom: 0;
    }
    h6:nth-child(1){
      padding-top: 10px;
    }
    h6:nth-child(2){
      padding-top: 10px;
    }
  }
}
.center{
  text-align: center;
}
.left{
  text-align: left;
}
.right{
  text-align: right;
}
.weight{
  font-weight: 700;
}
.row_box{
  border-bottom: 1px solid #eee;
}
.big_box4{
  width: 98%;
  // padding: 40px;
  background: #fff;
  // box-shadow: 0 2px 10px #ddd;
  margin: 0 auto;
  box-sizing: border-box;
}
.qsly{
  margin: 4px 5px 0 0;
  float: right;
  color: #666;
  // border: 0;
  // background: #fff;
  cursor: pointer;
}
</style>
